import styles from "./assertion-error-messages.less";
import classNames from "classnames";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { useSelector } from "react-redux";
import { getLanguageContent } from "@redux/selectors/language-selectors";

type AssertionErrorMessagesProps = {
    messages: Array<string>;
};

export const AssertionErrorMessages = (props: AssertionErrorMessagesProps) => {
    const { messages } = props;
    const content = useSelector(getLanguageContent);

    if (!messages.length) {
        return <></>;
    }
    
    return (
        <div className={classNames(styles.assertionErrorMessages, "assertion-error-messages-container")}>
            <div className={classNames(styles.errorHeader, "assertion-error-messages-header")}>
                <FontAwesomeIcon icon={faExclamationCircle} className={styles.errorIcon} />
                <span>{content.form.messages.assertionErrorTitle}</span>
            </div>
            <ul className={classNames(styles.errorList, "assertion-error-messages-list")}>
                {messages.map((errorMessage, index) => {
                    return (
                        <li key={index} className={`header-message-content`}>
                            {errorMessage}
                        </li>
                    );
                })}
            </ul>
            <div className={classNames(styles.errorFooter, "assertion-error-messages-footer")}>
                <span>{content.form.messages.assertionErrorRetry}</span>
            </div>
        </div>
    );
}